import { gql } from '@apollo/client'
import { client } from '../client';


const REGISTER_TRANSPORTATION_MUTATION = gql`
  mutation Mutation($qtirLanguageId: Int!, $authCode: String!, $phoneNumber: String, $registrationNumber: String, $transportationId: Int, $transportationTypeId: Int, $driverName: String, $carCompanyId: Int, $destinationId: Int, $carQuantity: Int, $driverEmail: String, $voyage: String) {
    registerTransportation(qtirLanguageId: $qtirLanguageId, authCode: $authCode, phoneNumber: $phoneNumber, registrationNumber: $registrationNumber, transportationId: $transportationId, transportationTypeId: $transportationTypeId, driverName: $driverName, carCompanyId: $carCompanyId, destinationId: $destinationId, carQuantity: $carQuantity, driverEmail: $driverEmail, voyage: $voyage) {
      transportationId
    }
  }
`

interface RegisterTransportationData {
  registerTransportation: {
    transportationId: number
  }
}

interface RegisterTransportationVars {
  qtirLanguageId: number,
  authCode: string,
  transportationId?: number,
  transportationTypeId?: number,
  phoneNumber?: string,
  registrationNumber?: string,
  driverName?: string,
  carCompanyId?: number,
  destinationId?: number,
  carQuantity?: number,
  driverEmail?: string,
  voyage?: string,
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const registerTransportation = (args: RegisterTransportationVars) => {
  return client.mutate<RegisterTransportationData, RegisterTransportationVars>({
    mutation: REGISTER_TRANSPORTATION_MUTATION,
    variables: args,
  })
}
